import { selectKrcAgeRangeNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const KRC_AGE_RANGE: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcAgeRangeNode,
  information: {
    single: 'Leeftijdsbereik',
    plural: 'Leeftijdsbereiken',
  },
  buildingBlocks: [],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
      required: RequiredType.ERROR,
    },
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default KRC_AGE_RANGE;
